import React, { forwardRef, useState } from 'react';
import { Avatar as MuiAvatar, AvatarProps, Box, styled } from '@mui/material';

export const DEFAULT_USER_AVATAR_IMG =
    'https://ssl.gstatic.com/images/branding/product/1x/avatar_circle_blue_512dp.png';

const AvatarWrapper = styled(Box)(({ theme }) => {
    return {
        backgroundColor: theme.palette.background.default,
        border: `1px solid ${theme.palette.border.main}`,
        borderRadius: '50%',
        width: 'fit-content',
        padding: '2px',
    };
});

export const UserAvatar = forwardRef<HTMLDivElement, AvatarProps>(
    ({ src, children, alt, ...otherProps }, ref) => {
        const [imageError, setImageError] = useState(false);

        // Fallback to initials if image fails
        const getInitials = (name: string | undefined) => {
            if (!name || name.toLowerCase().trim() === 'unknown') return '';

            return name
                .split(' ')
                .map((n) => n[0])
                .join('')
                .toUpperCase();
        };

        return (
            <AvatarWrapper>
                <MuiAvatar
                    {...otherProps}
                    ref={ref}
                    src={!imageError ? src : undefined}
                    alt={alt}
                    onError={() => setImageError(true)}
                    >
                    {children || getInitials(alt)}
                </MuiAvatar>
            </AvatarWrapper>
        );
    }, 
);

export default UserAvatar;
